
export default (event) => {
  window.localStorage.removeItem("token")
  window.location = "/"
}
